import * as api from 'constants/api';
import fetch from 'helpers/Fetch';

export const getDailySummary = payload =>
  fetch({
    url: api.URL_MMPAY_DAILY_SUMMARY,
    data: payload,
  });

export const getTransactions = payload =>
  fetch({
    url: api.URL_MMPAY_TRANSACTIONS,
    data: payload,
  });
